module.exports = __webpack_public_path__ + "img/Wp_2079.75f0cd5a.png";